










































































































































































































import {Component, Watch} from 'vue-property-decorator'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import NavHeaderMenu from '@/components/NavHeaderMenu.vue'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {SimpleListContractSchema} from '@/schema/resource/Contract/SimpleListContractSchema'
import PercentageProgress from '@/components/misc/PercentageProgress.vue'
import FilterContractClient, {
  getSortOptions,
} from '@/components/filters/FilterContractClient.vue'
import {SortOption} from '@/types/SortOption'
import {Dapp} from '@/model/resource/Dapp'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import ContractsChart from '@/components/ContractsChart.vue'
import {MetaInfo} from 'vue-meta'
import DappDetailedStatsChart from '@/components/dappDetailed/DappDetailedStatsChart.vue'
import DappDetailedSummary from '@/components/dappDetailed/DappDetailedSummary.vue'
import DappsHeader from '@/components/DappsHeader.vue'
import {DappInfo} from '@/model/resource/DappInfo'
import {Dictionary} from '@simpli/meta-schema/dist/types/Dictionary'

@Component({
  components: {
    DappDetailedStatsChart,
    DappDetailedSummary,
    ContractsChart,
    FilterContractClient,
    PercentageProgress,
    Navbar,
    NavHeaderMenu,
    FilterToggle,
    AppFooter,
    DappsHeader,
  },
})
export default class ContractsView extends MixinScreenSize {
  collection = new ContractCollection()
  schema = new SimpleListContractSchema()

  dapp = new Dapp()
  dappInfo = new DappInfo()

  idExpanded: number | null = null
  selectedContractId: number | null = null

  private sorterOptions = getSortOptions()

  sorterField: SortOption = this.sorterOptions[5]

  async created() {
    this.applyCollection()
    await this.populateResources()
  }

  applyCollection() {
    this.collection.perPage = 10
    this.collection.orderBy = 'recentTransactionCount'
    this.collection.asc = false
    this.collection.private = false
  }

  async populateResources() {
    const promises: Array<Promise<unknown>> = [this.collection.expand()]

    await Promise.all(promises)
  }

  @Watch('idExpanded')
  async expandEvent(idContractPk: number | null) {
    const contract =
      this.collection.items.find(it => it.$id === idContractPk) ?? null

    await this.$await.run(`getDapp_${contract?.idContractPk}`, async () => {
      if (contract?.dapp) {
        await this.dapp.getDapp(contract.dapp.$id)

        const promises: Array<Promise<unknown>> = [
          this.dappInfo.getInfoDapp(this.dapp.slug ?? ''),
        ]

        await Promise.all(promises)
      }
    })
  }

  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.contracts'),
    }
  }

  filterHeaders(headers: Dictionary<string>) {
    if (!this.isMobile) {
      return headers
    }

    return Object.entries(headers).reduce((acc, [key, value]) => {
      if (key === 'rank') {
        acc[key] = ''
      }

      if (key === 'dapp') {
        acc[key] = value
      }

      return acc
    }, {} as Dictionary<string>)
  }

  filterItems(list: string[]) {
    return list.filter(item =>
      this.isMobile ? !['title', 'hash'].includes(item.toLowerCase()) : true
    )
  }

  onOrderBy() {
    const findSorterField = this.sorterOptions.find(
      ({field, asc}) =>
        field == this.collection.orderBy && asc === this.collection.asc
    )

    if (findSorterField) {
      this.sorterField = findSorterField
    }
  }

  headerName(value: string, key: number) {
    if (key === 1 && this.isMobile) {
      return this.schema.translateFrom('contract')
    }
    if (this.isMobile) {
      return [0].includes(key) ? '' : value
    }

    return value
  }

  headerClass(key: number) {
    if (this.isMobile) {
      if (key === 0) {
        return 'px-0'
      }
      if (key === 3 || key === 2) {
        return 'hidden'
      }
    }

    return null
  }

  rowClass(field: string) {
    if (field === 'rank' && this.isMobile) {
      return 'px-0'
    }

    return null
  }

  isExpanded(idContractPk: number) {
    return this.idExpanded === idContractPk
  }

  toggleExpand(idContractPk: number) {
    if (this.isExpanded(idContractPk)) {
      this.idExpanded = null
    } else {
      this.idExpanded = idContractPk
    }
  }
}
